import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import Line from '../../../../packages/kiti/components/helpers/Line'
import GalleryInput from '../../../../components/form/GalleryInput'

const OthersInfoSection = () => {
  const { t } = useTranslation('editStocks')
  return (
    <>
      <Separator weight={2} />
      <Title size="small" bold color="dark3">
        {t('sections.othersInfo')}
      </Title>
      <Line />
      <Separator weight={2} />
      <Grid paddingGutter={0.5} wrap>
        <Col width="50%" wrapOn="sm">
          <FormItem label={t('fields.barCode')} field="barCode" />
        </Col>
        <Col width="50%" wrapOn="sm">
          <FormItem label={t('fields.notes')} field="notes" />
        </Col>
        <Col width="100%">
          <FormItem
            label={t('fields.images')}
            field="documents"
            Input={GalleryInput}
            buttonLabel={t('fields.addFile')}
            accept={'image/*'}
            limit={1}
          />
        </Col>
      </Grid>
    </>
  )
}

export default OthersInfoSection
